<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขประเภทสินค้า(ย่อย)' : 'เพิ่มประเภทสินค้า(ย่อย)' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label class="form-label mb-0 required">รหัสชนิดสินค้า</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm"
                formControlName="productId"
                [compareWith]="compareByNumericValue">
          <option [ngValue]="null">กรุณาเลือก</option>
          @for (item of productCodes; track item.id) {
            <option [ngValue]="item.id">{{ item.productCode || '-' }} - {{ item.title || '' }}</option>
          }
        </select>
        @if (isProductCodeLoading) {
          <div class="form-text">กำลังโหลดรหัสชนิดสินค้า...</div>
        }
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-4"><label class="form-label mb-0 required">ประเภทสินค้า(ย่อย)</label></div>
      <div class="col-sm-8"><textarea class="form-control form-control-sm" rows="4" formControlName="value"></textarea></div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
